import React, { useState } from 'react';
import { 
  Typography, 
  TextField, 
  Button, 
  Box,
  Paper,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';

const DataCollectionHelper = () => {
  const [problem, setProblem] = useState('');
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateRecommendations = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/generateDataCollectionRecommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ problem }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate recommendations');
      }
      const data = await response.json();
      setRecommendations(data.recommendations);
    } catch (error) {
      console.error('Error generating recommendations:', error);
      setError('Failed to generate recommendations. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'white' }}>
        <Box sx={{ mb: 4 }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={problem}
            onChange={(e) => setProblem(e.target.value)}
            placeholder="Describe the behavior problem or context (e.g., 'Frequent tantrums during homework time' or 'Need to track progress on using communication device')"
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={generateRecommendations}
            disabled={loading || !problem}
          >
            Get Recommendations
          </Button>
        </Box>
        {loading && <CircularProgress />}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {recommendations.length > 0 && (
          <Box>
            <Typography variant="h6" gutterBottom>
              Recommended Data Collection Methods:
            </Typography>
            <List>
              {recommendations.map((rec, index) => (
                <React.Fragment key={index}>
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={rec.method}
                      secondary={
                        <>
                          <Typography
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Description: 
                          </Typography>
                          {" " + rec.description}
                          <br />
                          <Typography
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Why it's suitable: 
                          </Typography>
                          {" " + rec.suitability}
                        </>
                      }
                    />
                  </ListItem>
                  {index < recommendations.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default DataCollectionHelper;
